import React, { useEffect, useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ViewTabs } from "../../../../common/components";
import styles from "./DSIData.module.css";
import { translate } from "../../../../common/providers";
import DSIExportUser from "../dsi-export-user/DSIExportUser";
import DSISearchTemplates from "../dsi-search-templates/DSISearchTemplates";
import DSIExportTemplates from "../dsi-exporttemplates/DSIExportTemplates";
import DSICompany from "../dsi-company/DSICompany";
import DSIUsers from "../dsi-users/DSIUsers";
import DSIProjects from "../dsi-projects/DSIProjects";
import DSICanvas from "../dsi-canvas/DSICanvas";

export default function DSIData({
	activeUsersInCompany,
	companies,
	companyRolesInProject,
	userRolesInCompany,
	userRolesInProject,
	onAddExistingPartnerToProject,
	onAddExistingUserToProject,
	onChangeBlockUser,
	onCreateBu,
	onCreateCompany,
	onCreateUser,
	onRegeneratePassword,
	onSelectCompany,
	onUpdateCompany,
	onUpdateCompanyRoleInProject,
	onUpdateUserStatusInProject,
}) {
	const [selectedTab, setSelectedTab] = useState(0);
	const navigate = useNavigate();
	const { tab, subTab } = useParams();
	const tabs = useMemo(
		() => [
			{
				label: translate("dsi.tab.tooltip.company-management"),
				param: "company",
				component: (
					<DSICompany
						activeUsersInCompany={activeUsersInCompany}
						companies={companies}
						onCreateBu={onCreateBu}
						onCreateCompany={onCreateCompany}
						onSelectCompany={onSelectCompany}
						onUpdateCompany={onUpdateCompany}
					/>
				),
			},
			{
				label: translate("dsi.tab.tooltip.member-management"),
				param: "users",
				component: (
					<DSIUsers
						companies={companies}
						userRolesInCompany={userRolesInCompany}
						userRolesInProject={userRolesInProject}
						onChangeBlockUser={onChangeBlockUser}
						onCreateUser={onCreateUser}
						onRegeneratePassword={onRegeneratePassword}
						onUpdateUserStatusInProject={onUpdateUserStatusInProject}
					/>
				),
			},
			{
				label: translate("dsi.tab.tooltip.member-export"),
				param: "export-users",
				component: <DSIExportUser companies={companies} />,
			},
			{
				label: translate("dsi.tab.tooltip.project-management"),
				param: "project",
				component: (
					<DSIProjects
						companies={companies}
						companyRolesInProject={companyRolesInProject}
						userRolesInProject={userRolesInProject}
						onAddExistingPartnerToProject={onAddExistingPartnerToProject}
						onAddExistingUserToProject={onAddExistingUserToProject}
						onUpdateCompanyRoleInProject={onUpdateCompanyRoleInProject}
						onUpdateUserStatusInProject={onUpdateUserStatusInProject}
					/>
				),
			},
			{
				label: translate("dsi.tab.tooltip.document-management"),
				param: "canvas",
				component: <DSICanvas companies={companies} />,
			},
			{
				label: translate("dsi.tab.tooltip.search-templates"),
				param: "search-templates",
				component: <DSISearchTemplates />,
			},
			{
				label: translate("dsi.tab.tooltip.export-templates-management"),
				param: "export-templates",
				component: <DSIExportTemplates companies={companies} />,
			},
		],
		[
			activeUsersInCompany,
			companies,
			companyRolesInProject,
			userRolesInCompany,
			userRolesInProject,
			onAddExistingPartnerToProject,
			onAddExistingUserToProject,
			onChangeBlockUser,
			onCreateBu,
			onCreateCompany,
			onCreateUser,
			onRegeneratePassword,
			onSelectCompany,
			onUpdateCompany,
			onUpdateCompanyRoleInProject,
			onUpdateUserStatusInProject,
		]
	);
	useEffect(() => {
		if (subTab) {
			const index = tabs.findIndex((t) => t.param === subTab);
			if (index >= 0) {
				setSelectedTab(index);
			}
		}
	}, [tabs, subTab]);

	const handleChangeSelectedTab = (_, newTab) => {
		const { param } = tabs[newTab];
		setSelectedTab(newTab);

		if (tab && param) {
			navigate(`/dsi/${tab}/${param}`, { replace: true });
		}
	};
	return (
		<div className={styles.main}>
			<div className={styles.header}>
				<div className={styles.tabs}>
					<ViewTabs
						noPadding
						noShadow
						selectedTab={selectedTab}
						tabClassName={styles.tab}
						tabs={tabs}
						onChange={handleChangeSelectedTab}
					/>
				</div>
			</div>
			<div className={styles.compContainer}>{tabs[selectedTab].component}</div>
		</div>
	);
}
